<button odxButton variant="secondary" (click)="onClickDelete()" [disabled]="disabled" [odxTooltip]="tooltipTextDeleteItem">
  <odx-icon name="delete" size="medium"></odx-icon>
</button>
